<template>
  <v-row>
    <v-col
      cols="12"
    >
      <base-card>
        <iframe
          :src="logsUrl"
          width="100%"
          frameborder="0"
          style="min-height:100vh"
        />
      </base-card>
    </v-col>
  </v-row>
</template>

<script>
import { environment } from '@/data/environment'

export default {
  computed: {
    logsUrl() {
      return environment.LOGS_URL
    },
  },
}
</script>
